/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "adsb_regulatory_manager";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface VolumeDimensions {
  radius: number;
  height: number;
}

function createBaseVolumeDimensions(): VolumeDimensions {
  return { radius: 0, height: 0 };
}

export const VolumeDimensions = {
  encode(message: VolumeDimensions, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.radius !== 0) {
      writer.uint32(13).float(message.radius);
    }
    if (message.height !== 0) {
      writer.uint32(21).float(message.height);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VolumeDimensions {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVolumeDimensions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.radius = reader.float();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.height = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VolumeDimensions {
    return {
      radius: isSet(object.radius) ? globalThis.Number(object.radius) : 0,
      height: isSet(object.height) ? globalThis.Number(object.height) : 0,
    };
  },

  toJSON(message: VolumeDimensions): unknown {
    const obj: any = {};
    if (message.radius !== 0) {
      obj.radius = message.radius;
    }
    if (message.height !== 0) {
      obj.height = message.height;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VolumeDimensions>, I>>(base?: I): VolumeDimensions {
    return VolumeDimensions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VolumeDimensions>, I>>(object: I): VolumeDimensions {
    const message = createBaseVolumeDimensions();
    message.radius = object.radius ?? 0;
    message.height = object.height ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
